export const SUBTITLES_MANAGEMENT_AUTHORISATION = 'SUBTITLES_MANAGEMENT_AUTHORISATION';
export const SUBTITLE_VOICE_OVER_MEDIA="SUBTITLE_VOICE_OVER_MEDIA"
